import { Box, Typography } from "@mui/material";

type ReservationCalendarWeekdayHeaderProps = {
  weekdayLabels: string[];
};

export default function ReservationCalendarWeekdayHeader({
  weekdayLabels,
}: ReservationCalendarWeekdayHeaderProps) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
        gap: 0,
      }}
    >
      {weekdayLabels.map((label) => (
        <Typography
          key={label}
          sx={{
            textAlign: "center",
            lineHeight: 1,
            paddingY: 0.25,
            display: "block",
          }}
        >
          {label}
        </Typography>
      ))}
    </Box>
  );
}
